import * as React from "react";
import classnames from "classnames";
import { CheckboxWithLabel } from "@grandvisionhq/forms";
import { useIntl } from "@grandvisionhq/state";
import { CLStockIndicator } from "../../../../../../../../CLStockIndicator/modules/EcommContent/ContactLensesEcommContent/components/CLPrescriptionSelector/components/CLStockIndicator/CLStockIndicator.js";
/* empty css                          */
import { CLPrescriptionSelectContainer } from "../../../../../../../../CLPrescriptionSelect/modules/EcommContent/ContactLensesEcommContent/components/CLPrescriptionSelector/components/CLPrescriptionSelect/CLPrescriptionSelectContainer.js";
import { CLQuantitySelectorContainer } from "../../../../../../../../CLQuantitySelector/modules/EcommContent/ContactLensesEcommContent/components/CLPrescriptionSelector/components/CLQuantitySelector/CLQuantitySelectorContainer.js";
const CLPrescriptionColumn = React.memo(
  ({
    eyeSideId,
    className,
    columnTitle,
    parameters,
    isEnabled,
    showCheckboxError,
    onCheckboxChange,
    onAttributeChange,
    "data-t": dataT
  }) => {
    const { getLabel } = useIntl();
    const screenreaderTitle = `${getLabel(
      "products.contactLenses.prescription.title"
    )} ${columnTitle}`;
    const handleAttributeChange = React.useCallback(
      (name, value) => onAttributeChange(name, value, eyeSideId),
      [eyeSideId, onAttributeChange]
    );
    const handleCheckboxChange = React.useCallback(
      ({ checked }) => onCheckboxChange(checked, eyeSideId),
      [eyeSideId, onCheckboxChange]
    );
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classnames("cl-prescription-column", className),
        "aria-label": screenreaderTitle,
        "data-t": dataT,
        role: "group"
      },
      /* @__PURE__ */ React.createElement(
        CheckboxWithLabel,
        {
          id: eyeSideId,
          value: eyeSideId,
          checked: isEnabled,
          className: classnames("cl-prescription-column__title", `${className}--checkbox`),
          "data-t": "prescription-checkbox",
          label: columnTitle,
          onChange: handleCheckboxChange,
          disabled: false,
          error: showCheckboxError
        }
      ),
      parameters.map((attributeConfig) => /* @__PURE__ */ React.createElement(
        CLPrescriptionSelectContainer,
        {
          key: attributeConfig.name,
          selectClassName: "cl-prescription-column__dropdown",
          attributeConfig,
          eyeSideId,
          isDisabled: !isEnabled,
          onChange: handleAttributeChange
        }
      )),
      /* @__PURE__ */ React.createElement(
        CLQuantitySelectorContainer,
        {
          eyeSideId,
          className: "cl-prescription-column__quantity-select",
          isEnabled
        }
      ),
      /* @__PURE__ */ React.createElement(
        CLStockIndicator,
        {
          eyeSideId,
          className: classnames("cl-prescription-column__stock", `${className}--stock`)
        }
      )
    );
  }
);
export {
  CLPrescriptionColumn
};
//# sourceMappingURL=CLPrescriptionColumn.js.map
